import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { attributes, associations, IAttributes, IAssociations } from 'app/constants/schemas/quiz';

export interface IDialogSentenceQuiz extends IEntity {
  attributes: IAttributes & {
    id: EntityStringId;
  };
  associations: IAssociations;
}

export type DialogSentenceQuiz = Entity<IDialogSentenceQuiz>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DialogSentenceQuiz: IEntityType<IDialogSentenceQuiz> = vmClient.defineClass({
  typeName: 'DialogSentenceQuiz',
  version: 4,
  lockable: true,
  persisted: true,
  attributes,
  associations,
});
